import React, { useState, useEffect } from "react";
import apiClient from "../api/axiosInstance";

const EditInternshipPolicy = () => {
  const [policyContent, setPolicyContent] = useState([]);
  const [newSection, setNewSection] = useState("");
  const [newParagraph, setNewParagraph] = useState("");

  const fetchPolicyContent = async () => {
    try {
      const response = await apiClient.get("/api/internship-policies");
      setPolicyContent(response.data);
    } catch (error) {
      console.error("Error fetching policy content:", error);
    }
  };

  useEffect(() => {
    fetchPolicyContent();
  }, []);

  const handleDelete = async (id) => {
    try {
      await apiClient.delete(`/api/internship-policies/${id}`);
      setPolicyContent(policyContent.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Error deleting policy:", error);
    }
  };

  const handleEdit = async (id, section, paragraph) => {
    try {
      const updatedPolicy = { section, paragraph };
      await apiClient.put(`/api/internship-policies/${id}`, updatedPolicy);
      fetchPolicyContent(); // Refresh the list after edit
    } catch (error) {
      console.error("Error updating policy:", error);
    }
  };

  const handleAdd = async () => {
    try {
      const newPolicy = { section: newSection, paragraph: newParagraph };
      await apiClient.post("/api/internship-policies", newPolicy);
      fetchPolicyContent(); // Refresh the list after adding
      setNewSection(""); // Clear input fields
      setNewParagraph("");
    } catch (error) {
      console.error("Error adding policy:", error);
    }
  };

  return (
    <div className="w-full border-2 px-4 bg-white shadow-lg pb-4 pt-4 rounded-md overflow-y-auto h-[calc(100vh-14.5rem)]">
      <h2 className="text-xl font-bold mb-4 text-green-700">
        Edit Internship Policy
      </h2>

      {/* Policy list */}
      {policyContent.map((item) => (
        <div
          key={item.id}
          className="mb-6 flex flex-col sm:flex-row items-start"
        >
          {/* Section Input */}
          <div className="w-full sm:w-1/4 pr-4 mb-4 sm:mb-0">
            <label className="block mb-2 font-semibold">Section</label>
            <input
              type="text"
              value={item.section || ""}
              onChange={(e) =>
                setPolicyContent(
                  policyContent.map((policy) =>
                    policy.id === item.id
                      ? { ...policy, section: e.target.value }
                      : policy
                  )
                )
              }
              className="border border-gray-300 p-2 w-full rounded"
            />
          </div>

          {/* Paragraph Input */}
          <div className="w-full sm:w-3/4">
            <label className="block mb-2 font-semibold">Paragraph</label>
            <textarea
              value={item.paragraph || ""}
              onChange={(e) =>
                setPolicyContent(
                  policyContent.map((policy) =>
                    policy.id === item.id
                      ? { ...policy, paragraph: e.target.value }
                      : policy
                  )
                )
              }
              className="border border-gray-300 p-2 w-full h-32 resize-y rounded"
            />
          </div>

          {/* Actions */}
          <div className="ml-auto mt-2 sm:mt-0 sm:ml-4">
            <button
              onClick={() => handleEdit(item.id, item.section, item.paragraph)}
              className="bg-blue-500 hover:bg-blue-700 rounded-[8px] p-2 px-10 text-white flex mt-8"
            >
              Edit
            </button>
            <button
              onClick={() => handleDelete(item.id)}
              className="bg-red-500 hover:bg-blue-700 rounded-[8px] p-2 px-8 text-white flex mt-4"
            >
              Delete
            </button>
          </div>
        </div>
      ))}

      {/* Add New Section */}
      <div className="mt-8">
        <h3 className="text-lg font-semibold mb-4">Add New Section</h3>
        <div className="flex flex-col sm:flex-row items-start">
          {/* New Section Input */}
          <div className="w-full sm:w-1/2 pr-4 mb-4 sm:mb-0">
            <label className="block mb-2 font-semibold">Section</label>
            <input
              type="text"
              placeholder="Section Title"
              value={newSection}
              onChange={(e) => setNewSection(e.target.value)}
              className="border border-gray-300 p-2 w-full rounded"
            />
          </div>

          {/* New Paragraph Input */}
          <div className="w-full sm:w-1/2">
            <label className="block mb-2 font-semibold">Paragraph</label>
            <textarea
              placeholder="Paragraph"
              value={newParagraph}
              onChange={(e) => setNewParagraph(e.target.value)}
              className="border border-gray-300 p-2 w-full h-32 resize-y rounded"
            />
          </div>

          {/* Add Button */}
          <div className="ml-auto mt-4 sm:mt-0 sm:ml-4">
            <button
              onClick={handleAdd}
              className="bg-green-700 text-white px-8 py-2 rounded"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditInternshipPolicy;
